import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { deLocale, thLocale } from 'ngx-bootstrap/locale';
defineLocale('th', deLocale);
import { JwtHelperService } from '@auth0/angular-jwt'
import { ScanService } from '../../services/scan.service';
@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss']
})
export class ReportSummaryComponent implements OnInit {
  d1: Date;
  config: any;
  dep: string;
  date1: string;
  ds1: string;
  scan_data: any = [];
  ds_1: string;
  userid: string;

  rowHeight: number = 8;
  p: number = 1;

  jwtHelper = new JwtHelperService();

  constructor(private datePipe: DatePipe,
    private localeService: BsLocaleService
    , private scanService: ScanService) {
    defineLocale('th', thLocale);
    this.localeService.use('th');
  }

  ngOnInit() {
    this.d1 = new Date();
    this.date1 = this.datePipe.transform(this.d1, "yyyy-MM");
    this.userid = sessionStorage.getItem('userid');

    this.ds_1 = this.datePipe.transform(this.ds1, "yyyy-MM");
  }

  name = 'Angular';
  modelDate = '';

  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  async getScan() {
    this.ds_1 = this.datePipe.transform(this.ds1, "yyyy-MM");

    console.log(this.ds_1+"  "+this.userid);

    try {
      const rs: any = await this.scanService.getSummaryByOne(this.userid, this.ds_1);
      
      if (rs.ok == true) {
        this.scan_data = rs.results;
      }
    } catch (error) {
      console.log(error);
    }

  }
}
